module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music"
  }, [_c('div', {
    ref: "banner",
    staticClass: "banner"
  }, [_c('a', {
    staticClass: "back-btn",
    attrs: {
      "href": "#/"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Music")])]), _vm._v(" "), _c('div', {
    staticClass: "applemusic"
  }, [_c('iframe', {
    style: ({
      height: _vm.musicHeight + 'px'
    }),
    attrs: {
      "src": "//tools.applemusic.com/embed/v1/album/1252032972?at=10lPYF"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7efa2176","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Music.vue
// module id = 65
// module chunks = 1